@if (!isRepeatUser) {
    <img class="wave" src="{{ DEPLOY_URL }}/assets/images/wave-reversed.png" alt="wave-reversed" />
}
<br />
<div class="review-container" [ngClass]="!isRepeatUser ? 'shaded' : 'white'">
    <img class="heart" src="{{ DEPLOY_URL }}/assets/images/heart.png" alt="heart" />
    <h1>
        Over
        <span class="brand-color">20L+ happy customers</span>
        <br class="break" />
        and counting...
    </h1>
    <app-image-slider
        [images]="testimonials"
        [wrapperClass]="'testimonial-carousel'"
        [categoryBanner]="true"
        [infiniteScroll]="true"
        [bannerAlignment]="'left'">
    </app-image-slider>
</div>

@if (banners.length > 0) {
    <div class="trending">
        <h1>What’s <span class="brand-color">trending?</span></h1>
        <app-image-slider [images]="banners" [wrapperClass]="'mweb-offer-carousel'" [infiniteScroll]="true"></app-image-slider>
    </div>
}

<article class="about-us container">
    <article class="details">
        <h1 class="heading">When in doubt,&nbsp;</h1>
        <h1 class="brand-color heading">Order Desi!</h1>
        <br />
        <img src="{{ DEPLOY_URL }}/assets/images/quote-mark.svg" class="quote" alt="quote" />
        <div class="details-text">
            Too lazy to cook or bored of ghar ka khana? Tired of scrolling through restaurants or stuck on a concall? Whatever the
            reason, When In Doubt, Order Desi!
            <br /><br />
            From Dal Makhni to Amritsari Chole Chawal to Butter Chicken to Gulab Jamun, we have all of your delicious Desi Meals.
        </div>
    </article>
    <div class="image-container">
        <div class="top">
            <img
                class="img-1"
                src="{{ DEPLOY_URL }}/assets/images/missing.png"
                appDeferImageLoad
                imageSrc="{{ DEPLOY_URL }}/assets/images/mweb_story/story-01.jpg"
                alt="story" />
            <img
                class="img-2"
                src="{{ DEPLOY_URL }}/assets/images/missing.png"
                appDeferImageLoad
                imageSrc="{{ DEPLOY_URL }}/assets/images/mweb_story/story-02.jpg"
                alt="story" />
        </div>
        <div class="bottom">
            <img
                class="img-3"
                src="{{ DEPLOY_URL }}/assets/images/missing.png"
                appDeferImageLoad
                imageSrc="{{ DEPLOY_URL }}/assets/images/mweb_story/story-03.jpg"
                alt="story" />
            <img
                class="img-4"
                src="{{ DEPLOY_URL }}/assets/images/missing.png"
                appDeferImageLoad
                imageSrc="{{ DEPLOY_URL }}/assets/images/mweb_story/story-04.jpg"
                alt="story" />
            <img src="{{ DEPLOY_URL }}/assets/images/dot-pattern.svg" class="dot-pattern" alt="dot-pattern" />
        </div>
    </div>
</article>

<article class="news-container container">
    <h1>In the News!</h1>
    <div class="flex-wrapper">
        @for (news of newsLinks; track news) {
            <div class="news">
                <img
                    class="news-icon"
                    alt="news-icon"
                    role="button"
                    tabindex="0"
                    src="{{ DEPLOY_URL }}/assets/images/missing.png"
                    appDeferImageLoad
                    (click)="openArticleLink(news.url)"
                    [imageSrc]="news.image" />
            </div>
        }
    </div>
</article>
